var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E89C05",
    d: "M11.997,20.301c-1.733,0-3.467,0.001-5.199,0c-0.668,0-0.958-0.297-0.965-0.966 c-0.011-0.981,0.011-1.954,0.334-2.901c0.899-2.638,3.511-4.367,6.29-4.145c2.96,0.234,5.309,2.463,5.656,5.398 c0.072,0.604,0.059,1.221,0.047,1.832c-0.008,0.489-0.359,0.779-0.889,0.779C15.514,20.302,13.755,20.301,11.997,20.301z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E89C05",
    d: "M11.994,3.696c2.216-0.003,4.02,1.786,4.025,3.996c0.008,2.221-1.797,4.037-4.015,4.042 C9.803,11.739,7.986,9.932,7.981,7.73C7.976,5.502,9.769,3.7,11.994,3.696z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E89C05",
    d: "M18.955,13.423c-1.646-0.007-2.984-1.352-2.98-2.995c0.002-1.635,1.36-2.99,2.993-2.988 c1.652,0.001,2.994,1.356,2.987,3.015C21.948,12.101,20.605,13.43,18.955,13.423z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E89C05",
    d: "M5.039,13.423c-1.651,0.001-2.988-1.328-2.993-2.977C2.041,8.791,3.393,7.434,5.042,7.439 c1.637,0.006,2.986,1.359,2.986,2.997C8.027,12.079,6.685,13.421,5.039,13.423z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E89C05",
    d: "M4.73,20.292c-1.023,0-2.044,0.021-3.062-0.008c-0.674-0.021-1.181-0.634-1.184-1.349 c-0.009-1.961,1.328-3.762,3.212-4.324c0.522-0.155,1.053-0.237,1.612-0.185C4.398,16.316,3.724,18.21,4.73,20.292z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E89C05",
    d: "M19.266,20.301c0.934-1.908,0.44-3.684-0.373-5.436c-0.063-0.135-0.14-0.264-0.25-0.471 c0.396,0.027,0.742,0.023,1.078,0.08c2.162,0.355,3.771,2.231,3.797,4.41c0.008,0.826-0.541,1.405-1.36,1.413 C21.195,20.309,20.234,20.301,19.266,20.301z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberIcon);
export default __webpack_public_path__ + "static/media/member-icon.a09e733318909b155d553c249165f030.svg";
export { ForwardRef as ReactComponent };